// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__SjCgi","box":"WorkspacesBox_box__1bMgE","node":"WorkspacesBox_node__2XrxP"};